<script>
  export let height = "45"
</script>

<img src="/logo.svg" alt="SBI" {height} />
